export default "__VITE_ASSET__EL9La81e__"